import { userEventTypes } from 'events/user';
import initialState from 'reducers/initialStates/user';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case userEventTypes.USER_UPDATE:
    case userEventTypes.USER_CREATE:
    case userEventTypes.USER_ADD_CREDENTIALS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
